import { createContext, memo, PropsWithChildren, useCallback, useContext, useMemo, useState } from 'react';
import { PRODUCTS } from '../utils/data';
import { CheckoutOptions, CheckoutType, Product } from '../utils/types';

export interface SdkDemoContext {
  products: Product[];

  quantities: number[];
  setQuantities(quantities: number[]): void;

  totalAmount: number;

  options: CheckoutOptions;
  updateOptions(options: Partial<CheckoutOptions>): void;
}

const Context = createContext<SdkDemoContext | null>(null);

export const SdkDemoContextProvider = memo((props: PropsWithChildren<{}>) => {
  const products = PRODUCTS;

  const [quantities, setQuantities] = useState(() => products.map(() => 1));

  const [options, setOptions] = useState<CheckoutOptions>(() => ({
    type: CheckoutType.modal,
    language: '',
    showLanguageMenu: true,
    showHeader: true,
    log: true,
    merchantAccount: '',
    orderId: 'ORDER_123',
    orderSummary: 'Order summary',
  }));

  const updateOptions = useCallback(
    (data: Partial<CheckoutOptions>) => {
      setOptions({ ...options, ...data });
    },
    [options],
  );

  const totalAmount = useMemo(() => {
    let total = 0;

    products.forEach((product, index) => {
      total += product.price * (quantities[index] || 0);
    });

    return total;
  }, [products, quantities]);

  const context: SdkDemoContext = {
    products,

    quantities,
    setQuantities,

    options,
    updateOptions,

    totalAmount,
  };

  return <Context.Provider value={context}>{props.children}</Context.Provider>;
});

export function useSdkDemoContext() {
  return useContext(Context)!;
}
